import { Objection } from '../../objection/objection';
import { SessionMessage } from '../../session-message/session-message';

export function evaluateSoftSkillsObjectionAnswerPrompt(messageList: SessionMessage[], objection: Objection) {
  let chatHistory = '';

  messageList.forEach((message) => {
    chatHistory += `Sales: ${message.subData.salesMessage} \n Customer: ${message.subData.customerMessage} \n`;
  });

  return `
Analyze chat history and score the Actual Answer below to evaluate objection handling effectiveness.
The actual answer to be graded and suggested answer should be the last message from the "Sales" in the chat history below as <CHAT_HISTORY>
- Suggestions : Reasoning for the score and improved response
- Improved Response : The improved response based on the suggestions
- Score (1-5) : The score should represent how well the sales reps keep engaging with customer.

Question: ${objection.title}
Suggested Answer Example: ${objection.description}

<CHAT_HISTORY>
${chatHistory}
</CHAT_HISTORY>
  `;
}

export function evaluateSoftSkillsObjectionAnswerFunctions(objection: Objection) {
  // score: number;
  // suggestions: string;
  // improvedResponse: string;
  return [
    {
      name: 'get_most_score_and_improved_response_for_actual_answer',
      description: `
Analyze chat history and score the Actual Answer below to evaluate objection handling effectiveness.
The actual answer to be graded and suggested answer should be the last message from the "Sales" in the chat history below as <CHAT_HISTORY>
- Suggestions : Reasoning for the score and improved response
- Improved Response : The improved response based on the suggestions
- Score (1-5) : The score should represent how well the sales reps keep engaging with customer.

Question: ${objection.title}
Suggested Answer Example: ${objection.description}
  `,
      parameters: {
        type: 'object',
        properties: {
          score: {
            type: 'number',
            description: 'the Score',
          },
          suggestions: {
            type: 'string',
            description: 'the Suggestions',
          },
          improvedResponse: {
            type: 'string',
            description: 'the Improved Response',
          },
        },
      },
    },
  ];
}

export function evaluateFactsBasedObjectionAnswerPrompt(messageList: SessionMessage[], objection: Objection) {
  let chatHistory = '';

  messageList.forEach((message) => {
    chatHistory += `Sales: ${message.subData.salesMessage} \n Customer: ${message.subData.customerMessage} \n`;
  });

  return `
Analyze chat history and score the Actual Answer below to evaluate objection handling effectiveness.
You should only check numbers, names, and dates and other scientifically verifiable information
You should not include language variations.
You should ignore any typo, grammatical errors, syntax errors or spelling errors.
You should not evaluate answers or messages that are not relevate to the question.

Question: ${objection.title}
Expected Accruate Answer: ${objection.description}

<CHAT_HISTORY>
${chatHistory}
</CHAT_HISTORY>

Output the following information:
- MissingInformations : The missing information in the actual answer. Return empty array if no scientifically verifiable missing information detected.
- InaccurateInformations : The inaccurate information in the actual answer. Return empty array if no scientifically verifiable inaccuracies detected.
- Score (1-5) : The score should represent how accurate the answers and chat history addresses the given facts
  `;
}

export function evaluateFactsBasedObjectionAnswerFunctions(objection: Objection) {
  // score: number;
  // missingInformationList: string[];
  // inaccurateInformationList: string[];
  return [
    {
      name: 'get_missing_or_inaccurate_facts_in_actual_answer',
      description: `parse and convert the following text to json format
  `,
      parameters: {
        type: 'object',
        properties: {
          score: {
            type: 'number',
            description:
              'Score (1-5) : The score should represent how accurate the answers and chat history addresses the given facts.',
          },
          objectionMissingInformationList: {
            type: 'array',
            description:
              'MissingInformations : The missing information in the actual answer, and the reasoning for the missing information',
            items: {
              type: 'object',
              properties: {
                missingInformation: {
                  type: 'string',
                },
                reasoning: {
                  type: 'string',
                },
              },
            },
          },
          objectionInaccurateInformationList: {
            type: 'array',
            description:
              'InaccurateInformations : The inaccurate information in actual answer, and the reasoning for the missing information',
            items: {
              type: 'object',
              properties: {
                inaccurateInformation: {
                  type: 'string',
                },
                reasoning: {
                  type: 'string',
                },
              },
            },
          },
        },
      },
    },
  ];
}
